// extracted by mini-css-extract-plugin
module.exports = {"barcode":"styles_barcode__1JRzj","fullHeight":"styles_fullHeight__XNGTM","minimized":"styles_minimized__2Ffpk"};